import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import styles from './style.module.scss';
import { DownloadIcon } from 'assets';

// Flatten object & extract 'name' where possible
const flattenObject = (obj, parentKey = '', res = {}) => {
    for (let key in obj) {
        const propName = parentKey ? `${parentKey}_${key}` : key;
        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
            if ('name' in obj[key]) {
                res[propName] = obj[key].name;
            } else {
                flattenObject(obj[key], propName, res);
            }
        } else if (Array.isArray(obj[key])) {
            res[`${propName}_count`] = obj[key].length;
        } else {
            res[propName] = obj[key];
        }
    }
    return res;
};

// Extract nested array data for second sheet
const extractNestedArrayData = (data, arrayKey) => {
    const rows = [];
    data.forEach(item => {
        if (Array.isArray(item[arrayKey])) {
            item[arrayKey].forEach(subItem => {
                const flat = {
                    parent_id: item._id
                };
                for (let key in subItem) {
                    if (typeof subItem[key] === 'object' && subItem[key] !== null) {
                        if ('name' in subItem[key]) {
                            flat[key] = subItem[key].name;
                        } else {
                            for (let nestedKey in subItem[key]) {
                                flat[`${key}_${nestedKey}`] = subItem[key][nestedKey];
                            }
                        }
                    } else {
                        flat[key] = subItem[key];
                    }
                }
                rows.push(flat);
            });
        }
    });
    return rows;
};

const ExcelExport = ({ data, fileName }) => {
    const exportToExcel = () => {
        const wb = XLSX.utils.book_new();

        // Sheet 1: Main Data
        const flatData = data.map(item => flattenObject(item));
        const ws1 = XLSX.utils.json_to_sheet(flatData);
        XLSX.utils.book_append_sheet(wb, ws1, 'Main Data');

        // Check if nested data exists
        const orderData = extractNestedArrayData(data, 'order');
        if (orderData.length > 0) {
            const ws2 = XLSX.utils.json_to_sheet(orderData);
            XLSX.utils.book_append_sheet(wb, ws2, 'Order Details');
        }

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `${fileName}.xlsx`);
    };

    return <button className={styles.exportbtn} onClick={exportToExcel}>Export to Excel <DownloadIcon /></button>;
};

export default ExcelExport;
